import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext, useMemo } from 'react';
import { Field } from '../Field';
import { Context } from './Context';
import { DISPLAY_NAME_LABEL } from './constants';
const Label = forwardRef((props, ref) => {
    const { id } = useContext(Context);
    const htmlForId = useMemo(() => `${id}-input`, [id]);
    return _jsx(Field.Label, { ...props, htmlFor: htmlForId, ref: ref });
});
Label.displayName = DISPLAY_NAME_LABEL;
export { Label };
//# sourceMappingURL=Label.js.map